import { createSlice } from "@reduxjs/toolkit";
import purge from "store/purge";

const defaultState = {
  zoomToPosition: undefined,
};

export default createSlice({
  name: "MAP",
  initialState: defaultState,
  reducers: {
    setZoomToPosition: (state, { payload }) => {
      state.zoomToPosition = payload;
    },
  },
  extraReducers: {
    ...purge(defaultState),
  },
});
